export class ElderColors {
  public static readonly whites = ['#DFE3E8', '#B3BCC8', '#8593A7', '#F6F3EC', '#E8E1D1', '#DACFB4']
  public static readonly blues = [
    '#546883',
    '#2F4869',
    '#0B284F',
    '#0A2448',
    '#092040',
    '#081C38',
    '#061529',
    '#809ec5',
    '#5179bf',
    '#004390',
    '#00006b',
  ]
  public static readonly golds = [
    '#CCBC96',
    '#C1AD80',
    '#B69F6A',
    '#A69160',
    '#948156',
    '#81714B',
    '#5F5337',
    '#e1d1a9',
    '#efd08f',
    '#dbbe7a',
    '#af9144',
  ]

  public static getAllColors(): string[] {
    return ElderColors.whites.concat(ElderColors.blues.concat(ElderColors.golds))
  }
}
